import { serializeArguments, setCookie, getCookie } from './Utils';
import history from './history';

var gStore = null;


export const navigateTo = (path, state = {}) => {
	history.push(path, state);
};

export function initAppActions(store)
{
	gStore = store;
}

export function restoreHistory(component)
{
	var cachedHistory = JSON.parse(getCookie("cachedHistory"));
	if( cachedHistory != null )
	{
		for( var i = 0; i < cachedHistory.length; i++ ) component.props.history.push(cachedHistory[i]);
	}
}

function getCachedHistory()
{
	var cachedHistory = getCookie("cachedHistory");
	if( typeof cachedHistory !== 'undefined' && cachedHistory != null )
	{
		try
		{
			cachedHistory = JSON.parse(cachedHistory);
		}
		catch(e)
		{
			console.log("error parsing cache");
			cachedHistory = [];
		}
	}
	
	return cachedHistory;
}

function setCachedHistory(cachedHistory)
{
	setCookie("cachedHistory", JSON.stringify(cachedHistory), 7);
}

export function push(component, componentName, options)
{
	var newRoute = {
	  pathname: '/'+componentName,
	  state: options
	};
	component.props.history.push(newRoute)

	// update cached history
	var cachedHistory = getCachedHistory();
	cachedHistory.push(newRoute);
	setCachedHistory(cachedHistory)
}

export function pop(component)
{
	component.props.history.goBack()

	// update cached history
	var cachedHistory = getCachedHistory();
	if( cachedHistory.length > 0 ) cachedHistory.pop();

	setCachedHistory(cachedHistory)
}

export function replace(component, componentName, options)
{
	var newRoute = {
	  pathname: '/'+componentName,
	  state: options
	};
	component.props.history.replace(newRoute)

	// update cached history
	var cachedHistory = getCachedHistory();

	if( cachedHistory == null ) cachedHistory = [];
	if( cachedHistory.length > 0 ) cachedHistory.pop();

	cachedHistory.push(newRoute);

	setCachedHistory(cachedHistory)
}


var _appActionActions = {};
export function registerListenerForAction(key, func)
{
	_appActionActions[key] = func;
	console.log(_appActionActions, key)
}

export function removeListenerForAction(key, func)
{
	if( typeof _appActionActions[key] !== 'undefined' ) delete _appActionActions[key];
}

export function triggerAction(key, vars)
{
	console.log(_appActionActions, key, vars)
	if( typeof _appActionActions[key] !== 'undefined' ) _appActionActions[key](vars);	
}